// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v1/job.proto (package infinigence.infini.agentplatform.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ChannelUser } from "./channel_pb.js";
import { file_agentplatform_v1_channel } from "./channel_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v1/job.proto.
 */
export const file_agentplatform_v1_job: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_v1_channel]);

/**
 * @generated from message infinigence.infini.agentplatform.v1.AgenticJobSpec
 */
export type AgenticJobSpec = Message<"infinigence.infini.agentplatform.v1.AgenticJobSpec"> & {
  /**
   * 发送者（含 open_id 等完整信息）
   * @gotags: json:"sender,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelUser sender = 1;
   */
  sender?: ChannelUser | undefined;

  /**
   * 聊天类型：p2p / group / thread（与 InboundMessage 一致）
   * @gotags: json:"chat_type,omitempty"
   *
   * @generated from field: string chat_type = 2 [json_name = "chat_type"];
   */
  chatType: string;

  /**
   * 聊天ID（根据 chat_type 决定含义）
   * @gotags: json:"chat_id,omitempty"
   *
   * @generated from field: string chat_id = 3 [json_name = "chat_id"];
   */
  chatId: string;

  /**
   * 智能体输入
   * @gotags: json:"agent_input,omitempty"
   *
   * @generated from field: string agent_input = 4 [json_name = "agent_input"];
   */
  agentInput: string;

  /**
   * 智能体实例 Application ID
   * @gotags: json:"application_id,omitempty"
   *
   * @generated from field: string application_id = 5 [json_name = "application_id"];
   */
  applicationId: string;

  /**
   * 智能体模版 Agent ID
   * @gotags: json:"agent_id,omitempty"
   *
   * @generated from field: string agent_id = 6 [json_name = "agent_id"];
   */
  agentId: string;

  /**
   * 渠道账号 ID（用于推送通知路由）
   * @gotags: json:"channel_account_id,omitempty"
   *
   * @generated from field: string channel_account_id = 7 [json_name = "channel_account_id"];
   */
  channelAccountId: string;

  /**
   * 渠道类型
   * @gotags: json:"channel_type,omitempty"
   *
   * @generated from field: string channel_type = 8 [json_name = "channel_type"];
   */
  channelType: string;

  /**
   * 渠道用户 ID（caller_user_id）
   * @gotags: json:"caller_user_id,omitempty"
   *
   * @generated from field: string caller_user_id = 9 [json_name = "caller_user_id"];
   */
  callerUserId: string;

  /**
   * 原始消息平台 ID（用于推送通知时回复原始消息）
   * @gotags: json:"channel_message_id,omitempty"
   *
   * @generated from field: string channel_message_id = 10 [json_name = "channel_message_id"];
   */
  channelMessageId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.AgenticJobSpec.
 * Use `create(AgenticJobSpecSchema)` to create a new message.
 */
export const AgenticJobSpecSchema: GenMessage<AgenticJobSpec> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_job, 0);

/**
 * @generated from message infinigence.infini.agentplatform.v1.RagCrawlerJobSpec
 */
export type RagCrawlerJobSpec = Message<"infinigence.infini.agentplatform.v1.RagCrawlerJobSpec"> & {
  /**
   * web | sitemap
   * @gotags: json:"kind,omitempty"
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @gotags: json:"urls,omitempty"
   *
   * @generated from field: repeated string urls = 2;
   */
  urls: string[];

  /**
   * @gotags: json:"sitemap_url,omitempty"
   *
   * @generated from field: string sitemap_url = 3 [json_name = "sitemap_url"];
   */
  sitemapUrl: string;

  /**
   * @gotags: json:"collection_id,omitempty"
   *
   * @generated from field: string collection_id = 4 [json_name = "collection_id"];
   */
  collectionId: string;

  /**
   * @gotags: json:"collection_display_name,omitempty"
   *
   * @generated from field: string collection_display_name = 5 [json_name = "collection_display_name"];
   */
  collectionDisplayName: string;

  /**
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 6 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 7 [json_name = "user_id"];
   */
  userId: string;

  /**
   * @gotags: json:"vector_size,omitempty"
   *
   * @generated from field: optional int32 vector_size = 8 [json_name = "vector_size"];
   */
  vectorSize?: number | undefined;

  /**
   * @gotags: json:"chunk_overlap,omitempty"
   *
   * @generated from field: optional int32 chunk_overlap = 9 [json_name = "chunk_overlap"];
   */
  chunkOverlap?: number | undefined;

  /**
   * @gotags: json:"distance,omitempty"
   *
   * @generated from field: string distance = 10;
   */
  distance: string;

  /**
   * rag ingest job id from the most recent cron fire
   * @gotags: json:"last_ingest_job_id,omitempty"
   *
   * @generated from field: string last_ingest_job_id = 11 [json_name = "last_ingest_job_id"];
   */
  lastIngestJobId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.RagCrawlerJobSpec.
 * Use `create(RagCrawlerJobSpecSchema)` to create a new message.
 */
export const RagCrawlerJobSpecSchema: GenMessage<RagCrawlerJobSpec> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_job, 1);

/**
 * @generated from message infinigence.infini.agentplatform.v1.Job
 */
export type Job = Message<"infinigence.infini.agentplatform.v1.Job"> & {
  /**
   * 任务ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 任务名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 任务描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * 租户ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 4 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户ID
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 5 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 任务类型
   * @gotags: json:"type"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.JobType type = 6;
   */
  type: JobType;

  /**
   * @generated from oneof infinigence.infini.agentplatform.v1.Job.schedule
   */
  schedule: {
    /**
     * @gotags: json:"cron,omitempty"
     *
     * @generated from field: string cron = 7;
     */
    value: string;
    case: "cron";
  } | {
    /**
     * @gotags: json:"run_at,omitempty"
     *
     * @generated from field: int64 run_at = 8 [json_name = "run_at"];
     */
    value: bigint;
    case: "runAt";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from oneof infinigence.infini.agentplatform.v1.Job.job_spec
   */
  jobSpec: {
    /**
     * @gotags: json:"agentic,omitempty"
     *
     * @generated from field: infinigence.infini.agentplatform.v1.AgenticJobSpec agentic = 9;
     */
    value: AgenticJobSpec;
    case: "agentic";
  } | {
    /**
     * @gotags: json:"rag_crawler,omitempty"
     *
     * @generated from field: infinigence.infini.agentplatform.v1.RagCrawlerJobSpec rag_crawler = 10 [json_name = "rag_crawler"];
     */
    value: RagCrawlerJobSpec;
    case: "ragCrawler";
  } | { case: undefined; value?: undefined };

  /**
   * 创建时间
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 14 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * 更新时间
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 15 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * 删除时间
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 16 [json_name = "deleted_at"];
   */
  deletedAt: bigint;

  /**
   * 任务状态
   * @gotags: json:"status"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.JobStatus status = 17;
   */
  status: JobStatus;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.Job.
 * Use `create(JobSchema)` to create a new message.
 */
export const JobSchema: GenMessage<Job> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_job, 2);

/**
 * @generated from message infinigence.infini.agentplatform.v1.JobRun
 */
export type JobRun = Message<"infinigence.infini.agentplatform.v1.JobRun"> & {
  /**
   * 运行记录ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 所属任务ID
   * @gotags: json:"job_id"
   *
   * @generated from field: string job_id = 2 [json_name = "job_id"];
   */
  jobId: string;

  /**
   * 租户ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 3 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 运行状态
   * @gotags: json:"status"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.JobRunStatus status = 4;
   */
  status: JobRunStatus;

  /**
   * 开始时间（UnixNano）
   * @gotags: json:"started_at,omitempty"
   *
   * @generated from field: int64 started_at = 5 [json_name = "started_at"];
   */
  startedAt: bigint;

  /**
   * 结束时间（UnixNano）
   * @gotags: json:"finished_at,omitempty"
   *
   * @generated from field: int64 finished_at = 6 [json_name = "finished_at"];
   */
  finishedAt: bigint;

  /**
   * 运行耗时（毫秒）
   * @gotags: json:"duration_ms,omitempty"
   *
   * @generated from field: int64 duration_ms = 7 [json_name = "duration_ms"];
   */
  durationMs: bigint;

  /**
   * 运行结果
   * @gotags: json:"result,omitempty"
   *
   * @generated from field: string result = 8;
   */
  result: string;

  /**
   * 失败时的错误信息
   * @gotags: json:"error_message,omitempty"
   *
   * @generated from field: string error_message = 9 [json_name = "error_message"];
   */
  errorMessage: string;

  /**
   * 创建时间
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 11 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * 更新时间
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 12 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * 删除时间
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 13 [json_name = "deleted_at"];
   */
  deletedAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.JobRun.
 * Use `create(JobRunSchema)` to create a new message.
 */
export const JobRunSchema: GenMessage<JobRun> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_job, 3);

/**
 * @generated from enum infinigence.infini.agentplatform.v1.JobType
 */
export enum JobType {
  /**
   * 未指定
   *
   * @generated from enum value: JOB_TYPE_UNSPECIFIED = 0;
   */
  JOB_TYPE_UNSPECIFIED = 0,

  /**
   * agentic job
   *
   * @generated from enum value: AGENTIC = 1;
   */
  AGENTIC = 1,

  /**
   * rag crawler embeding
   *
   * @generated from enum value: RAG_CRAWLER = 2;
   */
  RAG_CRAWLER = 2,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.JobType.
 */
export const JobTypeSchema: GenEnum<JobType> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_job, 0);

/**
 * @generated from enum infinigence.infini.agentplatform.v1.JobStatus
 */
export enum JobStatus {
  /**
   * 未指定
   *
   * @generated from enum value: JOB_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 运行中（CRON 任务活跃期间为 RUNNING，每次触发产生 JobRun；SINGLE 单次任务等待执行时也为 RUNNING）
   *
   * @generated from enum value: JOB_STATUS_RUNNING = 1;
   */
  RUNNING = 1,

  /**
   * 已完成（仅 SINGLE 单次任务执行成功后进入此状态）
   *
   * @generated from enum value: JOB_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * 已暂停（用户手动暂停，不再触发）
   *
   * @generated from enum value: JOB_STATUS_PAUSED = 3;
   */
  PAUSED = 3,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.JobStatus.
 */
export const JobStatusSchema: GenEnum<JobStatus> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_job, 1);

/**
 * @generated from enum infinigence.infini.agentplatform.v1.JobRunStatus
 */
export enum JobRunStatus {
  /**
   * 未指定
   *
   * @generated from enum value: JOB_RUN_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 等待中
   *
   * @generated from enum value: JOB_RUN_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * 运行中
   *
   * @generated from enum value: JOB_RUN_STATUS_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * 完成
   *
   * @generated from enum value: JOB_RUN_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * 失败
   *
   * @generated from enum value: JOB_RUN_STATUS_FAILED = 4;
   */
  FAILED = 4,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.JobRunStatus.
 */
export const JobRunStatusSchema: GenEnum<JobRunStatus> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_job, 2);

